module.exports = __webpack_public_path__ + "Assets/840b1eda-acf5-4788-867d-beaf576d7600.eot";